function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.09082 9.57941H19.909V18.5498C19.909 19.0974 19.4694 19.5414 18.9195 19.5414H5.08032C4.53383 19.5414 4.09082 19.1005 4.09082 18.5498V9.57941ZM9.07548 13.534H15.0073V11.5567H9.07548V13.534ZM5.42756 5.48101C5.72023 5.01445 6.40192 4.63623 6.94643 4.63623H17.0534C17.5996 4.63623 18.2788 5.01312 18.5723 5.48101L19.909 7.61203H13.3021H4.09082L5.42756 5.48101ZM11.0113 4.63623H12.9885V7.60214H11.0113V4.63623Z"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 4,
  width: 16,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.09082 9.57941H19.909V18.5498C19.909 19.0974 19.4694 19.5414 18.9195 19.5414H5.08032C4.53383 19.5414 4.09082 19.1005 4.09082 18.5498V9.57941ZM9.07548 13.534H15.0073V11.5567H9.07548V13.534ZM5.42756 5.48101C5.72023 5.01445 6.40192 4.63623 6.94643 4.63623H17.0534C17.5996 4.63623 18.2788 5.01312 18.5723 5.48101L19.909 7.61203H13.3021H4.09082L5.42756 5.48101ZM11.0113 4.63623H12.9885V7.60214H11.0113V4.63623Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

function SvgIcReAnnotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgIcReAnnotation);
export default __webpack_public_path__ + "static/media/ic-re-annotation.78b72816.svg";
export { ForwardRef as ReactComponent };